import { ExamItem, ExamResult } from '@/app/exam/ui/exam-dashboard-types';
import i18n from '@/plugins/i18n'

export const examsDashboardMixin = {
  methods: {
    formatPerformedOn(exam: ExamItem, filters: any|undefined): string {
      if (exam.status === 'not-attempted') {
        return '';
      }

      if (filters) {
        return filters.date(exam.effectiveAttempt.timestamp);
      }

      return '';
    },

    finalExamCircleLabel(finalExam: ExamItem|null): string {
      if (finalExam === null) {
        return '';
      }

      return this.examPassed(finalExam) ? i18n.t('dashboard.final_exam_result_succeeded').toString() :
            i18n.t('dashboard.final_exam_result_failed').toString();
    },

    examPassed(examResult: ExamResult): boolean {
      if (examResult.status === 'not-attempted') {
        return false;
      }

      return examResult.effectiveAttempt.result === 'passed';
    },

    getExamDescription(examResult: ExamResult): string {
      if (examResult.status === 'not-attempted') {
        return '';
      }

      const score = examResult.effectiveAttempt.score;
      return i18n.t('dashboard.final_exam_result_score', { raw: score.raw, max: score.max}).toString();
    }
  }
};
